import { Dispatch } from 'redux';
import axios from 'axios';
import { Content } from '../reducers/ContentReducer';
import { E_LEARNING_API_BASE_URL } from '../../config/config';

export const getDataList = (slug: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: 'CONTENT_LOADING' });

    try {
      const response = await axios.post<Content[]>(
        `${E_LEARNING_API_BASE_URL}get-data`,
        { slug },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch({ type: 'CONTENT_SUCCESS', payload: response.data });
    } catch (error: any) {
      dispatch({
        type: 'CONTENT_ERROR',
        payload: error.message || 'Failed to fetch data',
      });
    }
  };
};

export const getData = (slug: any, content: any) => {
  return async (dispatch: Dispatch) => {
    dispatch({ type: 'CONTENT_LOADING' });

    try {
      const response = await axios.post<Content[]>(
        `${E_LEARNING_API_BASE_URL}get-content`,
        { slug, content },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      dispatch({ type: 'CONTENT_SUCCESS', payload: response.data });
    } catch (error: any) {
      dispatch({
        type: 'CONTENT_ERROR',
        payload: error.message || 'Failed to fetch data',
      });
    }
  };
};
